/**
 * The file name a public page's build outputs share (scripts/prerender.mjs): its snapshot `dist/_prerender/<name>.html`
 * and its social card `dist/og/<name>.jpg`. "home" for `/`, else the path with "-" for "/" (`/legal/privacy` →
 * "legal-privacy", `/de/pricing` → "de-pricing"). Pure: the SPA (seo.ts) and the web Worker (worker/pages.ts) import it,
 * and the prerender script repeats the rule (src/lib/worker-pages.test.ts pins both).
 */
export const snapshotName = (path: string): string => (path === "/" ? "home" : path.slice(1).replaceAll("/", "-"));
